import { Tab } from '@models/company/tab';

export class PresentationTab extends Tab {}
